export class DiscountModel {
    discount_seq_no: number
    discount_desc: string
    discount_percent: number
    private _header: string

    set header(value: string) {
        this._header = value;
    }
    get header(): string {
        let strTmp = '';
        strTmp += `${this.discount_desc} -- ${this.discount_percent}%`;
        return strTmp
    }

    constructor(
        discount_seq_no: number,
        discount_desc: string,
        discount_percent: number
    ) {
        this.discount_seq_no = discount_seq_no
        this.discount_desc = discount_desc
        this.discount_percent = discount_percent
    }
}